import { createSlice } from "@reduxjs/toolkit";
export const systemSlice = createSlice({
  name: "system",
  initialState: {
    carousel: [],
    review: [],
    systemImage: {},
    bankDepositAccount: [],
    jackpot: {},
    bankList: [],
  },
  reducers: {
    setCarousel: (state, action) => {
      state.carousel = action.payload;
    },
    setReview: (state, action) => {
      state.review = action.payload;
    },
    setSystemImage: (state, action) => {
      state.systemImage = action.payload;
    },
    setDepositBankAccount: (state, action) => {
      state.bankDepositAccount = action.payload;
    },
    setJackpot: (state, action) => {
      state.jackpot = action.payload;
    },
    setBankList: (state, action) => {
      state.bankList = action.payload;
    },
  },
});

export const {
  setReview,
  setCarousel,
  setSystemImage,
  setDepositBankAccount,
  setJackpot,
  setBankList,
} = systemSlice.actions;
export const getReview = (state) => state.system.review;
export const getCarousel = (state) => state.system.carousel;
export const getSystemImage = (state) => state.system.systemImage;
export const getBankDepositAccount = (state) => state.system.bankDepositAccount;
export const getJackpot = (state) => state.system.jackpot;
export const getBankList = (state) => state.system.bankList;

export default systemSlice.reducer;
